import Solution from "./solution";

const testCases = [
  {
    arr: [1, 2, 3, 5, 6, 11, 15, 16, 17, 18],
    k: 20,
  },
  {
    arr: [1, 2, 3, 5, 6, 11, 15, 16, 17, 18],
    k: 11,
  },
  {
    arr: [1, 2, 3, 5, 6, 11, 15, 16, 17, 18],
    k: 90,
  },
  {
    arr: [1, 2, 3, 5, 6, 11, 15, 16, 17, 18],
    k: 17,
  },
  {
    arr: [1, 2, 3, 5, 6, 11, 15, 16, 17, 18],
    k: 23,
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr, k } = test;
      let outcome1 = output()(arr, k);
      let outcome2 = Solution(arr, k);
      const result = outcome1 === outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }
    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
